import React from 'react'
import { Icon } from '../../components/Icon'


const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-white h-[600px] overflow-scroll py-10 px-6 shadow  rounded-[1rem]">
    
      <div className="flex flex-col py-2 gap-3 justify-center align-middle items-center text-center">
        <Icon
          name={'IconLock'}
          width={52}
          height={52}
          strokeWidth={0.5}
          stroke="#02698C"
        />
        <p className="text-lg font-bold leading-6 text-text2">Privacy Policy</p>
      </div>
      <div className="mt-2">
        <p className="text-[9px] font-bold leading-4 text-text1">
          About Us and This Policy
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          This privacy policy (“Policy”) relates to the website available at
          (www.360safeguarding.io) and the 360safeguarding Online Database
          (“Product”) we provide as part of our services.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          The Site and Product are owned by Streamlearn Ltd, a company
          registered in England and Wales under company number Company No.
          12180453. Registered office: Axis 19 Mallard Way, Riverside Business
          Park, Swansea Vale, Swansea, SA7 0AJ.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          This Privacy Policy sets out the basis on which Streamlearn Ltd will
          process personal information provided to us, this information is also
          referred to as ‘personal data’. This privacy notice shall also apply
          to our subsidiary companies based at Axis 19 Mallard Way, Riverside
          Business Park, Swansea Vale, Swansea, SA7 0AJ including, for the
          purposes of this privacy notice, all references to “we”, “us”, “our”
          and “ours” refer to Streamlearn Ltd and shall include all subsidiary
          companies. We take our obligations in respect of the privacy of
          personal data very seriously and we will only process personal
          information as detailed in this notice unless we inform you otherwise.
          References in this Policy to “you” or “your” refer to the individual
          submitting information via the website or our online database
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          We are committed to safeguarding and preserving the privacy of
          visitors to our website. This notice is to explain how we may use
          personal information we collect when you:
        </p>
        <ul className="my-3 list-disc pl-3">
          <li className="text-[9px] font-normal leading-4 text-text1">
            browse our website;
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            register for an account to use our product;
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            access our content or services; or
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            communicate with us, for example by email.
          </li>
        </ul>
        <p className="text-[9px] font-normal leading-4 text-text1">
          If you become a customer of ours and use our Products or services,
          please be advised that any information that you hold about others and
          that any information which you upload to our Products or Services will
          be held in accordance with our Data Sharing and Processing Agreement
          and will be held in accordance with all Data Protection Laws.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          360 Safeguarding Online Database Personal Data Ownership and
          Responsibility
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          Streamlearn Ltd are providing a third-party hosting service for this
          product: For the purposes of Data Protection your own organisation is
          the Data Controller for personal data shared within this platform.
          Please refer to your organisations Data Protection representative for
          information relating to how this data is processed and how to exercise
          your rights as a data subject; Data you Share With Us About Others:
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          Once you have become a customer of a Streamlearn Ltd Product then all
          data you upload to the Product will be held and processed in
          accordance with our Data Sharing and Processing Agreement (copy
          available on request). Streamlearn Ltd will be the Data Processor of
          such data. This Privacy Policy does not apply to the data which you
          upload to the Streamlearn Ltd Product about others as this is
          addressed as part of the Data Sharing and Processing Agreement.
          Privacy Notice
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          Streamlearn Ltd will commit to sufficient resources and management
          oversight to ensure its full compliance with all relevant legislation,
          specifically in the case of privacy, the Data Protection Act 2018, the
          General Data Protection Regulation and the Protection of Personal
          Information Act. In order to ensure that the personal data we hold is
          accurate and up to date, we request that you inform us of any relevant
          changes to the personal information we hold about you.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          Streamlearn Ltd will commit to sufficient resources and management
          oversight to ensure its full compliance with all relevant legislation,
          specifically in the case of privacy, the Data Protection Act 2018, the
          General Data Protection Regulation and the Protection of Personal
          Information Act.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          In respect of the Data Protection Act 2018, and the Personal Data as
          described in this policy, Streamlearn Ltd is the Data Controller and
          is therefore responsible for the processing and storage of your
          Personal Data in accordance with Data Protection Law. “Personal Data”
          is defined as information from which a living person can be
          identified. Such information must be protected in accordance with Data
          Protection Act 2018.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          This Privacy Notice covers:
        </p>
        <ol className="list-decimal pl-3">
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            How we collect your Personal Data and why?
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            What type of personal information we collect about you?
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            Legal basis for collecting and using your personal information
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            Personal information we share with third parties
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            Data retention, data security and data transfers
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            How do we use Cookies?
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            Your Right
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            How can you access or correct your personal information, request
            that it be deleted, or ask for it to be transferred to another
            organisation?
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            How to make a subject access request or complaint?
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            Changes to this Privacy Notice
          </li>
          <li className="text-[9px] font-bold leading-4 text-text1 mt-1">
            Contact Us
          </li>
        </ol>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          1. How we collect your Personal Data and why
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          If you submit an enquiry via this site or proceed to use our product
          and/or services then we will collect certain Personal Data from you.
          This Personal Data will include the information that you have
          voluntarily supplied to us. Please see the list below to see the types
          of personal information we collect from or on behalf of our clients,
          along with an explanation of why we collect it and where we collect it
          from.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          We may monitor your use of the website through ‘cookies’ and similar
          tracking technologies. We may also monitor traffic, location and other
          data and information about users of the Site. Such data and
          information, to the extent that you are individually identifiable from
          it, shall constitute Personal Data. However, some of this information
          will be aggregated or statistical, which means that we will not be
          able to identify you individually.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          When you submit an enquiry, we will request your consent to use your
          personal data for the purposes that we set out in this Policy. We will
          process your personal data in accordance with this Policy.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          We only obtain and process information on a need-to basis in order to
          carry out our contract with our subscribing clients. For these
          reasons, the information we process can vary from one establishment to
          another, depending on what data the subscribing establishment chooses
          to share with us and the tools they want to use within the 360
          Safeguarding platform.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          We collect your personal data for one of the following purposes:
        </p>
        <ul className="list-disc pl-3">
          <li className="text-[9px] font-normal leading-4 text-text1">
            To manage communications between you and us
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To form a valid contract with you in respect of our products and/or
            services and fulfilling our obligations to you pursuant to that
            contract;
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To provide you with information you have requested or which we may
            feel may be of interest to you
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            For administration, maintenance and improvements to our website and
            our products/services
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To ensure the safe operation of our website and to monitor the
            performance of our website
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To comply with our legal obligations.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            For marketing and advertising purposes.
          </li>
        </ul>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          2. What type of personal information we collect about you
        </p>
        <table className="table-auto w-full my-5">
          <thead>
            <tr>
              <th className="border border-[#3487A2] p-3 text-left text-[9px] font-bold leading-[11px] text-text1">
                Type of information collected
              </th>
              <th className="border border-[#3487A2] p-3 text-left text-[9px] font-bold leading-[11px] text-text1">
                Reason for collection
              </th>
              <th className="border border-[#3487A2] p-3 text-left text-[9px] font-bold leading-[11px] text-text1">
                Sources
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Your full name - current and former
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                This is how we identify you. If we do not know who you are, we
                cannot provide our services. We may need former names to conduct
                a DBS check, as old records may be held under a former name.
              </td>
              <td className="border border-[#3487A2] p-3 text-left">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Public records
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Credit reference agencies
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Third parties
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Date of birth
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Along with your name, this serves to identify you as a unique
                individual, and is often required for us to perform our services
                as outlined in the contract.
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Place of birth
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Some services require a place of birth.
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Sex or gender
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Some services require a sex or gender.
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Ethnicity
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Some services require your ethnicity
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Whether you have a Disability
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Some services require confirmation of whether you have a
                disability and if so, details of your disability
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Contact information such as Telephone number, e-mail address
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                In most cases, we need to know how to get in touch with you.
                This may include your mailing address, email address and
                telephone number. If we collect these while providing services
                for a client, well use them only to provide those services and
                comply with our clients instructions and our legal obligations.
                We will not contact you for any other reason.
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Identification Documentation
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                We may be required to do so to complete our services as outlined
                in the contract. If so, we may collect two valid forms of proof
                of Identity (such as Passport, Photo-Card Driving Licence,
                National ID Card etc)
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    A third party that collects your documents or verifies your
                    identity for the purpose of transferring that information to
                    us.
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Employment history
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Some clients wish to verify employment or activity history over
                a period of time.
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Your current or past employers or their recordkeeping
                    service providers
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Agencies that placed you with your current or past employers
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Referees you have provided
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Credit reference agencies
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Government agencies
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Education history
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Some clients wish to verify education or activity history over a
                period of time.
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Educational institutions you have attended or their
                    recordkeeping service providers
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Government education authorities in jurisdictions where you
                    have attended school
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Referees you have provided
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Professional credentials, designations, licences, memberships,
                qualifications
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Some clients wish to verify your standing as a certain type of
                professional; participation or completion of professional
                development courses; or details of training courses completed in
                line with your employment requirements.
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Professional organisations with which you have been
                    associated, or their recordkeeping service providers
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Public records Employment history sources
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Referees you have provided
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Employment history sources
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                References
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Some clients wish to obtain character references about you.
                Additionally, opinions may be provided during verifications of
                employment or volunteering.
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You or our client
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Your current or past employers or their recordkeeping
                    service providers
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Agencies that placed you with your current or past employers
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Referees you have provided
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Educational institutions you have attended or their
                    recordkeeping service providers Media coverage
                  </li>
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    Media coverage
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                Your opinions about your experience with Streamlearn Ltd
              </td>
              <td className="border border-[#3487A2] p-3 text-[9px] font-normal leading-[14px] text-text1 text-left">
                We may occasionally seek your feedback about your interactions
                with us to improve the quality of our service.
              </td>
              <td className="border border-[#3487A2] p-3">
                <ul className="list-disc pl-3">
                  <li className="text-[9px] font-normal leading-[14px] text-text1">
                    You
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          Types of information, some of which may be personal information, that
          are logged when you access our secure platforms:
        </p>
        <ul className="list-disc pl-4">
          <li className="text-[9px] font-normal leading-4 text-text1">
            IP address.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Location.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Login credentials for our systems.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Dates, times and lengths of sessions.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Access to and modification of data.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Browser type and version.
          </li>
        </ul>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          3. Legal basis for collecting and using your personal information.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          Under Data Protection Law, we may only process your Information if we
          have a “legal basis” (i.e. a legally permitted reason) for doing so.
          We will have a legal basis for processing your Information under this
          Policy if:
        </p>
        <ul className="list-inside list-disc">
          <li className="text-[9px] font-normal leading-4 text-text1">
            The information is necessary for the performance of the contract.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            We are using your personal information for our legitimate interests.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            We have a legal obligation to process your personal information.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            You have consented to the use of your personal information.
          </li>
        </ul>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-6">
          a) Performance of a Contract
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          We will use your personal information for the following purposes where
          it is necessary to perform a contract or enter into a contract with
          you. This includes but not limited to:
        </p>
        <ul className="list-inside list-disc">
          <li className="text-[9px] font-normal leading-4 text-text1">
            To authenticate your identity and administer your user account ID.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To deal with your enquiries, requests, and purchases.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To provide you with Safeguarding tools
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To enable our data processors provide you with products and services
            requested by you.
          </li>
        </ul>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-6">
          b) Legitimate Interest
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          We may use your personal information where we have a legitimate
          business interest to do so. This includes but is not limited to:
        </p>
        <ul className="list-inside list-disc my-5">
          <li className="text-[9px] font-normal leading-4 text-text1">
            To personalise aspects of our services to you
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To carry out market research or surveys about our products and
            services.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            For marketing and strategic development purposes.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            For the proper keeping of business records.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To provide you with updates about developments on the Sites.
          </li>
        </ul>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-6">
          c) Legal Obligation
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          We will use your personal information where we are legally obliged to
          do so, this includes but is not limited to:
        </p>
        <ul className="list-inside list-disc my-5">
          <li className="text-[9px] font-normal leading-4 text-text1">
            Financial reporting and auditing purposes.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Where we will carry out DBS Checks on you as per the client’s
            request
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            For anti-money laundering or fraud prevention, detection, and
            reporting
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            To maintain records of actions taken on your account
          </li>
        </ul>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-6">
          d) Consent
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-1">
          We will use your personal information where we have your consent to do
          so:
        </p>
        <ul className="list-inside list-disc mt-1">
          <li className="text-[9px] font-normal leading-4 text-text1">
            To provide you with direct marketing information related to
            information about the products and services we offer.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Where you have provided us with your consent, we may use your
            personal information to enable data processors to contact you in
            relation to the services offered in conjunction with us or in
            respect of the services that they provide.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Where we rely on your consent to process your personal information,
            you can amend your email preferences at any time by logging into
            your account here.
          </li>
        </ul>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-6">
          It is your responsibility to ensure that any information you submitted
          as part of the registration process to your user account is accurate
          and up to date.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          4. Personal information we share with third parties.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          We may share your personal information with third-party processors or
          suppliers that we engage with to provide you with products and
          services you require (such as carrying out DBS Checks). These third
          parties may need to process your personal information on our behalf to
          provide such services. Where this is the case, we take great care to
          only engage with reliable third parties who can guarantee the security
          of your personal information and our business information.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          To protect your personal information, every third party we engage with
          completes a due diligence questionnaire to ensure their practices and
          procedures provide a reasonable level of security that we would expect
          (and is required under the data protection laws) when processing
          personal information.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Where a legal basis of processing applies, we may share your personal
          information with data processors (who may also be data controllers in
          respect of the information that we share). If you have any concerns
          about how your personal information is handled, you must get in touch
          with your institution as they may be data controllers for your
          personal information.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          In any event that Streamlearn Ltd decides to sell or transfer a
          product or service which we provide to you, or to an organisation whom
          you work for, we may transfer a subset of your data to them to ensure
          you can continue to access that product and service uninterrupted.
          Prior to the transfer of your data, we will contact you with the
          third-party details. We will give you reasonable opportunity to
          opt-out sharing your data with the third party.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          In certain circumstances, we may be required by law to disclose your
          personal information to government agencies and other organisations
          such as law enforcement agencies, banks or other financial
          institutions and data protection regulators
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          5. Data Retention, Data Transfer and Data Security
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Data retention:
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Record retention is necessary for our operational business purposes
          and in some cases required to fulfil statutory, regulatory, and/or
          contractual obligations.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          We will only keep your personal information for as long as they serve
          a useful business purpose or until all legal and regulatory
          requirements are met. This means we will retain personal information
          for the duration of any contract we have with you, in line with any
          legal obligation for record retention (such as that for HMRC or
          Ofsted) or until erasure is requested by you.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Data security:
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Streamlearn Ltd takes information security very seriously.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Certainly, here’s a slightly more formal revision of the data security
          section for a privacy policy: We are committed to the rigorous
          protection of your personal data. To this end, we have implemented
          robust security measures, to defend against external threats,
          continuous monitoring systems to detect any signs of unauthorised
          access, and the application of encryption protocols to secure data
          both in transit and at rest. Our data storage facilities are secured
          within premises that enforce stringent security standards, with
          regular evaluations performed by external auditing firms to ensure the
          integrity of our security practices. Access to sensitive information
          by our personnel is facilitated through secure virtual desktop
          environments, meticulously designed to maintain data confidentiality.
          Furthermore, our web interfaces are encrypted and password-secured,
          ensuring an additional layer of protection for your personal
          information.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          We employ equally rigorous physical security policies to prevent
          physical access to our premises. Our servers and offices are kept in
          access-controlled and monitored environments. We also enter into
          contracts with service providers which we may need to share your
          personal information. These contracts require service providers to
          protect your personal information to the same level we do. They also
          allow us to audit the service providers compliance with that
          obligation.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Data Transfer:
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          The personal information that we collect from you will, where
          possible, be stored in the United Kingdom (the UK). In certain
          circumstances, we may require third parties that are based outside of
          the UK or the EEA to process, host or store your personal information.
          By submitting your personal information to us, you acknowledge and
          agree to this processing, storage, or transfer of the data.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Please note that countries in other jurisdictions may not have the
          same standard of data protection laws in the UK or countries the EEA.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          In the event your personal information is processed or stored outside
          of the UK or the EEA, we will take all reasonable and necessary steps
          to ensure that your personal information is treated securely and in
          accordance with this Privacy Notice and applicable Data Protection
          Laws.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          We will only allow third parties to access your personal information
          where:
        </p>
        <ul className="list-inside list-disc mt-1">
          <li className="text-[9px] font-normal leading-4 text-text1">
            They are in countries that have been confirmed by the European
            Commission to provide an adequate level of protection for your data
            subjects’ rights and freedoms;
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            They have appropriate safeguards are in place such as Binding
            Corporate Rules or Standard Contractual Clauses approved by the
            European Commission and/or ICO;
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            There is a Data Sharing Agreement in place that allows us to
            transfer personal information between our subsidiaries.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            They have agreed to provide all protections to your personal
            information as set out in the Data Protection Laws (such as by
            entering into the European Commissions Model Clauses).
          </li>
        </ul>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Please be advised that the transmission of personal information via
          the internet is not completely secure. We will take reasonable steps
          to protect your personal information in line with our internal
          processes, however, we cannot fully guarantee the security of your
          data transmitted via email and/or our website. Any transmission made
          is at your own risk.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          6. How do we use cookies?
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Cookies are pieces of information shared between your web browser and
          a web site. Cookies enable the web site to collect information about
          your activities and give you a faster and easier experience. We use
          cookies for the following purposes:
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Where strictly necessary
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Cookies are essential to enable you to move around the website and use
          its features, such as accessing secure areas of the site. Without
          them, we could not provide services such as viewing certain areas of
          the site or using web forms. Cookies do not gather information about
          you that could be used for marketing or remembering where you have
          been on the internet.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-5">
          Performance:
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Cookies collect information about how visitors use a site, for
          instance which pages they go to and if they get error messages from
          web pages. Cookies do not collect information that identifies a
          person, as all the information they collect is anonymous. We use them
          to improve how our site works.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-5">
          Functionality:
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Cookies allow our site to remember choices you make (such as your
          language or the region you are in) and provide enhanced features. They
          can also be used to remember changes you have made to text size, font
          and other parts of web pages you can customise. They may be used to
          provide services you have requested such as viewing or commenting on
          content on the site. The information these cookies collect is usually
          anonymised.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-4">
          Please consult your web browsers Help documents for more information
          about how to turn cookies on and off.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          7. Your Rights
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          This section sets out your legal rights in respect of any of your
          Personal Data that we are holding and/or processing. If you wish to
          exercise any of your legal rights, you should put your request in
          writing to us (using our contact details below) giving us enough
          information to identify you and respond to your request.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          You have the right to request information about Personal Data that we
          may hold and/or process about you
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          You can also ask about:
        </p>
        <ul className="list-inside list-disc my-3">
          <li className="text-[9px] font-normal leading-4 text-text1">
            whether and why we have your personal information
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            how we got your personal information
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            what we have done with your personal information
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            to whom we have communicated your personal information
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            where your personal information has been stored, processed or
            transferred
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            how long we will retain your personal information, or how that
            retention period will be decided, and
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            the safeguards in place to protect your information when it is
            transferred to third parties or countries outside the EEA.
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Finally, you can ask us not to collect or use your personal
            information for certain purposes, you can ask us to delete your
            personal information, or you can ask us to provide your personal
            information to a third party.
          </li>
        </ul>
        <p className="text-[9px] font-normal leading-4 text-text1">
          You have the right to have any inaccurate information we hold about
          you be corrected and/or updated. If any of the Personal Data that you
          have provided changes, or if you become aware of any inaccuracies in
          respect of your Personal Data, please let us know in writing giving us
          enough information deal with the change or correction.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          You have the right in certain circumstances to request that we delete
          all Personal Data we hold about you (the ‘right of erasure’). Please
          note that this right of erasure is not available in all circumstances,
          for example where we need to retain the Personal Data for legal
          compliance purposes. If this is the case, we will let you know.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          You have the right in certain circumstances to request that we
          restrict the processing of your Personal Data, for example where the
          Personal Data is inaccurate or where you have objected to the
          processing.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          If we act as a processor on behalf of one of our clients, you will
          need to make any requests for the above directly to your potential
          employer. Any requests we receive from you that relate to such
          personal information will be referred to your potential employer.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          If you are not satisfied with the way your Data Subject Rights have
          been handled, you have the right to contact the Information
          Commissioners Office via www.ico.org.uk or by telephoning 0303 123
          1113.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          9. How to make a complaint?
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          You are entitled by law to ask for a copy of your personal information
          at any time. In the unlikely event that you have any concerns about
          how we use your personal information, please address any questions,
          comments and requests regarding our data processing practices to our
          Data Protection Officer at Mark@360safeguarding.io. This includes
          situations where you want to request the rectification or erasure of
          your personal information, restrictions to be placed around how we use
          your personal information, or to object to a particular use.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          If we are unable to resolve your complaint, you may make a complaint
          to the Information Commissioners Office. Please see
          https://ico.org.uk/make-a-complaint/ for more information.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 my-4">
          10. Changes to this Privacy Notice
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          We reserve the right to alter this privacy notice at any time. Such
          alterations will be posted on our website.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          It is your responsibility to ensure that you are aware of the latest
          version of this Notice and by continuing to use our services and/or
          our Sites, request services from us or otherwise engage with us, you
          will be deemed to have accepted the updated Notice.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          If you do not agree to any changes that we make, you should not use or
          access (or continue to use or access) our services and/or our Sites.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          This Policy was last updated on the 20 November 2023.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 my-5">
          11. Contact Us
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          360 Safeguarding is a trading name of Streamlearn Ltd.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Company No. 12180453.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Registered office:
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Axis 19 Mallard Way,
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Riverside Business Park,
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Swansea Vale,
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">Swansea,</p>
        <p className="text-[9px] font-normal leading-4 text-text1">SA7 0AJ.</p>
        <p className="text-[9px] font-normal leading-4 text-text1 my-4">
          Telephone no: (+44) 1792 700611
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1">
          Please address any questions, comments and requests regarding our data
          processing practices to our Data Protection Officer at
          Mark@360safeguarding.io
        </p>
      </div>
    </div>
  )
}

export default PrivacyPolicy
